import { render, staticRenderFns } from "./ViewInventoryChicks.vue?vue&type=template&id=3530e04b&scoped=true"
import script from "./ViewInventoryChicks.vue?vue&type=script&lang=js"
export * from "./ViewInventoryChicks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530e04b",
  null
  
)

export default component.exports